exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.wizard-modal .modal-dialog {\n\tposition: absolute;\n\ttop: 4rem;\n\tright: 1rem;\n\twidth: 100%;\n\tmax-width: 400px;\n\tmargin: 0;\n}\n.wizard-modal .modal-content {\n\tborder: none;\n}\n.wizard-modal .modal-body {\n\tborder-radius: 0.3rem;\n\tbackground-repeat: no-repeat;\n\tbackground-position: top center;\n\tbackground-size: 100% 80%;\n}\n.wizard-modal .modal-footer {\n\tborder-top: 0 none transparent;\n}\n.wizard-modal .wizard-modal-content strong {\n\tdisplay: block;\n\tpadding-top: 60px;\n\tpadding-bottom: 24px;\n}\n", ""]);

// exports
